import always from 'ramda/src/always'
import tryCatch from 'ramda/src/tryCatch'
import identity from 'ramda/src/identity'
import { DROP_ADD_MORE_MODAL_MODULE_ID, DROP_KEYS_LIST_MODULE_ID, EDIT_BRAND_KEYS_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { tableListType } from 'root/src/shared/constants/moduleTypes'
import { dropKey } from 'root/src/shared/descriptions/endpoints/recordTypes'
import displayModal from 'root/src/client/logic/modal/actions/displayModal'
import { camelCaseSpace } from 'root/src/shared/util/stringCase'
import { sectionKey } from 'root/src/shared/constants/keys'
import { dropKeyStatesEnum } from 'root/src/shared/constants/dropKeys'
import { RewardEndpoint } from 'root/src/shared/rewards/constants'

export default {
	[DROP_KEYS_LIST_MODULE_ID]: {
		moduleType: 'list',
		listType: tableListType,
		listModuleId: DROP_KEYS_LIST_MODULE_ID,
		listPayload: {
			section: dropKeyStatesEnum.available,
		},
		tableColumns: [
			['Game', ['game', 'name']],
			['Type', 'keyTypeReadable'],
			['Region', 'region', tryCatch(camelCaseSpace, always(undefined))],
			['Platform', 'platformReadable'],
			['Keys Available', 'available'],
			['Used', 'used'],
			['Creators Waiting', 'waiting', identity, true],
			['Restrictions', 'restrictions', identity, true],
		],
		tableItemActions: [
			{
				name: 'Add more',
				fn: item => displayModal(DROP_ADD_MORE_MODAL_MODULE_ID, item),
			},
			{
				name: 'Edit',
				fn: item => displayModal(EDIT_BRAND_KEYS_MODAL_MODULE_ID, item),
			},
		],
		listTitle: 'Keys',
		recordType: dropKey,
		endpointId: [RewardEndpoint.GET_DROP_KEY_REWARDS],
		embeddedContent: {
			moduleType: 'embeddedForm',
			fields: [
				{
					fieldId: sectionKey,
					fieldCaption: 'Status',
					fixedLargeWidth: true,
					inputType: 'dropdownEmbedded',
					options: [
						{
							label: 'Available',
							payload: {
								section: dropKeyStatesEnum.available,
							},
						},
						{
							label: 'All',
						},
					],
					endpointId: RewardEndpoint.GET_DROP_KEY_REWARDS,
				},
			],
		},
	},
}
